import { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Custom hook for proper GSAP cleanup
export const useGSAPCleanup = () => {
  useEffect(() => {
    return () => {
      // Kill all ScrollTriggers on unmount
      ScrollTrigger.getAll().forEach(st => st.kill());
      
      // Kill all GSAP animations
      gsap.killTweensOf("*");
      
      // Clear all delayed calls
      gsap.globalTimeline.clear();
      
      // Refresh ScrollTrigger
      ScrollTrigger.refresh();
    };
  }, []);
};

// Helper function to create GSAP context with proper cleanup
export const createGSAPContext = (callback, scope) => {
  const ctx = gsap.context(callback, scope);
  
  // Add custom cleanup method
  ctx.cleanup = () => {
    ctx.revert();
    
    // Additional cleanup for any remaining ScrollTriggers
    if (scope) {
      ScrollTrigger.getAll().forEach(st => {
        if (st.vars?.trigger) {
          const trigger = typeof st.vars.trigger === 'string' 
            ? document.querySelector(st.vars.trigger)
            : st.vars.trigger;
          
          if (trigger && scope && typeof scope.contains === 'function' && scope.contains(trigger)) {
            st.kill();
          }
        }
      });
    }
  };
  
  return ctx;
};